import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { useAuth } from '../../../auth';
import { getMonitoring, getMonitoringtenant } from '../request/request';
import { ViewGrafica } from '../Modal/ModalGraficas';

type monitoring = {

  displayName: string,
  status: any,
  SysUptime: string,
  StatusLicence: string,
  onlineLicence: string,
  connectedLicence: string,
  pingms: number,
  pingstatus: number,
  pingloss: number,
  diskAvailable: number,
  dskTotal: number,
  dskUsed: number,
  CPUload1m: number,
  CPUload1mlast10: [
    {
      clock: string,
      value: string
    }
  ]
  ramAvailable: string
  ramTotal: string
  ramUsed: string
  ping: [
    { ip: string, avg: string, source: string }]

  histping: [
    {
      timestamp: any,
      ping: [{ ip: string, avg: string, source: string }]
    }
  ]
  SerialLicence: any
  supportEndDate: any
  diasRestantes: any
  dataextra: { product: any, version: any }
}

type ID = undefined | null | number

function Connectivity(props: any) {
  const [ID, setID] = useState<ID>(undefined)
  const { currentUser } = useAuth()
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const [Loading, setLoading] = useState(false)


  /**********************Llamada a axios y parse de data**********************/
  /*********************se hacen cambios para poc filtroi por aws y azr*********************/

  const [datamonitoring, setdata] = useState<monitoring[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (props.tab === 1 && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(Id, Type, nameregion);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getMonitoringtenant(Id, tenant, Type, nameregion);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }
        else if (props.tab === 1 && Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(Id);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getMonitoringtenant(Id, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [Id, nameregion, props.tab])

  /**************llamadaglobal************* */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        if (props.tab === 1 && Id === -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(-1);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else if (tenant !== 0) {
            const available = await getMonitoringtenant(-1, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }

      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      } finally {
        setLoading(false); // Ocultar loading después de que se complete la petición
      }
    };

    fetchData();
  }, [tenant, Id, props.tab, Type])
  //////////////////////////////////////

  datamonitoring.forEach((item) => {
    // Obtén la fecha de expiración del elemento
    const fechaExpiracion = new Date(item.supportEndDate);

    // Calcula la diferencia en milisegundos entre la fecha de expiración y la fecha actual
    const diferenciaEnTiempo = fechaExpiracion.getTime() - new Date().getTime();

    // Convierte la diferencia en milisegundos a días
    const diferenciaEnDias = Math.ceil(diferenciaEnTiempo / (1000 * 3600 * 24));

    // Actualiza la propiedad "Días restantes hasta la expiración" de cada elemento con la diferencia calculada
    item.diasRestantes = diferenciaEnDias;
  });
  const diasRestantes = 30


  return (
    <>
      <div className='card'>
        {/* begin::Header */}


        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>

                {/* begin::Table */}
                <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                  {/* begin::Table head */}
                  {Type !== 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Uptime</th>
                      <th className='table-cell'>VSR Version</th>
                      <th className='table-cell'>Product License</th>
                      <th className='table-cell'>Subscription Expiration</th>
                      <th className='table-cell'>Status</th>


                    </tr>
                  </thead>}

                  {Type === 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Uptime</th>
                      <th className='table-cell'>VSR Version</th>
                      <th className='table-cell'>Product License</th>
                      <th className='table-cell'>Subscription Expiration</th>
                      <th className='table-cell'>Status</th>


                    </tr>
                  </thead>}

                  {/* end::Table head */}


                  {/* begin::Table body */}
                  {Type !== 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) => (
                          <tr key={i} className='table-row'>
                            {d.displayName.includes(Type) && <td className='table-cell'>{d.displayName}</td>}
                            {d.displayName.includes(Type) && <td className='table-cell'>{d.SysUptime}</td>}
                            {d.displayName.includes(Type) && (d.dataextra !== null ? <td className='table-cell'>{d.dataextra.version}</td> : <td className='table-cell'>---</td>)}
                            {d.displayName.includes(Type) && <td className='table-cell'>{d.SerialLicence}</td>}
                            {d.displayName.includes(Type) && (
                              <td className='table-cell'>
                                <div className={`badge ${d.diasRestantes > 90 ? 'badge-verde' : d.diasRestantes <= 30 ? 'badge-error' : 'badge-naranja'}`}>
                                  <p>{d.diasRestantes} <strong>{d.diasRestantes > 1 ? 'Days' : 'Day'}</strong></p>
                                </div>
                              </td>
                            )}
                            {d.displayName.includes(Type) && (
                              <td className='table-cell'>
                                {d.status === true ? (
                                  <p>Up</p>
                                ) : d.status === false ? (
                                  <p>Down</p>
                                ) : (
                                  '---'
                                )}
                              </td>
                            )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}

                  {Type === 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) => (
                          <tr key={i} className='table-row'>
                            <td className='table-cell'>{d.displayName}</td>
                            <td className='table-cell'>{d.SysUptime}</td>
                            {d.dataextra !== null ? <td className='table-cell'>{d.dataextra.version}</td> : <td className='table-cell'>---</td>}
                            <td className='table-cell'>{d.SerialLicence}</td>
                            <td className='table-cell'>
                              <div className={`badge ${d.diasRestantes > 90 ? 'badge-verde' : d.diasRestantes <= 30 ? 'badge-error' : 'badge-naranja'}`}>
                                <p>{d.diasRestantes} <strong>{d.diasRestantes > 1 ? 'Days' : 'Day'}</strong></p>
                              </div>
                            </td>
                            <td className='table-cell'>
                              {d.status === true ? (
                                <p>Up</p>
                              ) : d.status === false ? (
                                <p>Down</p>
                              ) : (
                                '---'
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}

                  {Id === 0 && Type === 'Global' && currentUser?.Tenant.Name !== 'DEMO' && currentUser?.Tenant.Name !== 'Telecom District' &&
                    <table className="table table-striped gy-7 gs-7">
                      <tbody>
                        <div className="text-center">
                          Select a Cloud with available subscriptions
                        </div>
                      </tbody>
                    </table>}
                  {/* end::Table body */}

                </table>
                {/* end::Table */}

              </div>


            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        <br />
        {/* end::Body */}
      </div>


    </>

  );

}

export default Connectivity